import React from "react";
import { Redirect } from "react-router";
import {
  MDBContainer, MDBCard, MDBCardBody, MDBBtn, MDBIcon,
  MDBRow, MDBCol, MDBTable, MDBTableBody, MDBTableHead
} from "mdbreact";
import API_URL from '../config';
import axios from 'axios';

import Select from 'react-select';
import generarBoletaPDF from './generarBoletaPDF';
import { puede, obtenerDatosSesion, obtenerModulos } from '../permisos';

class AdminBoletas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dniBusqueda: "",
      dniConfirmado: "",
      consultado: false,
      // Datos del trabajador
      datosPersonales: [],
      condicionesLaborales: [],
      planillas: [],
      periodos: [],
      boletapdf: [],
      usuario: "",
      autorizacion: "",
      planillaSeleccionada: "",
      periodoSeleccionado: "",
      cargando: false,
      mensajeError: '',
      redirigirBoleta: false,
      datosPersonalesPeriodo: [],
      planillasTrabajador: [],
      tipoPlanillaFiltro: 'remunerativas',
otrasPeriodos: [],
otrasPeriodoSel: '',
otrasPlanillasDisp: [],
otrasPlanillaSel: '',
otrasBoletapdf: [],
otrasDatosPersonales: [],
otrasPlanillasTrab: [],
mostrarDetalle: false,
mostrarDetalleOtras: false,
// Comprobante o expediente
// 11/08/2026 - compTipo decide cual de los dos formularios se muestra tras
// consultar el DNI. El expediente solo pide su numero: ni serie ni monto.
compTipo: 'COMPROBANTE',
compExpediente: '',
compTrabajadoresExpediente: 0,
compSerie: '',
compNumero: '',
compMonto: '',
compRegistrado: null,
compDescargasPermitidas: 0,
compDescargasRealizadas: 0,
compMensaje: '',
compError: '',
mostrarConfirmacion: false,
volverDashboard: false,
notificaciones: [],
// Búsqueda de trabajador por nombre
resultadosBusqueda: [],
buscandoTrabajador: false,
// Modal comprobante pendiente
modalCompPendiente: false,
compPendienteData: null,
datosPersonalesTemp: [],
condicionesLaboralesTemp: [],
verificandoDescarga: false
    };
  }

  refPeriodoRem = React.createRef();
  refPeriodoOtras = React.createRef();
  refOtrasCard = React.createRef();
  pollingInterval = null;

  componentDidMount() {
    var rol = this.getRol();
    // 11/08/2026 - se carga la primera página de trabajadores para que la
    // zona de abajo no arranque vacía.
    this.buscarTrabajadores('');
    if (rol === 'OPERADOR') {
      this.consultarNotificaciones();
    }
    if (rol === 'OPERADOR' || rol === 'ADMIN') {
      this.eventosInteraccion = ['mousedown', 'keydown', 'scroll', 'touchstart'];
      this.ultimaVerificacion = Date.now();
      this.handlerInteraccion = this.verificarEnInteraccion.bind(this);
      this.eventosInteraccion.forEach(function(ev) { window.addEventListener(ev, this.handlerInteraccion); }.bind(this));
    }
  }

  componentWillUnmount() {
    if (this.temporizadorBusqueda) clearTimeout(this.temporizadorBusqueda);
    if (this.eventosInteraccion && this.handlerInteraccion) {
      this.eventosInteraccion.forEach(function(ev) { window.removeEventListener(ev, this.handlerInteraccion); }.bind(this));
    }
  }

  verificarEnInteraccion = () => {
    var ahora = Date.now();
    if (ahora - this.ultimaVerificacion < 15000) return;
    this.ultimaVerificacion = ahora;
    this.verificarUsuarioActivo();
  }

  verificarUsuarioActivo = () => {
    var token = this.getToken();
    if (!token) return;
    var rol = this.getRol();
    if (!rol) return;
    axios.post(API_URL + '/verificarusuarioactivo/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ autorizacion: token })
    })
    .then(function(response) {
      if (response.data && response.data.length > 0 && response.data[0].activo === 0) {
        sessionStorage.clear();
        window.location.replace('/');
      }
    })
    .catch(function() { /* Error de red: no cerrar sesión */ });
  }

  consultarNotificaciones = () => {
    var token = this.getToken();
    if (!token) return;
    axios.post(API_URL + '/notificaciones/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ autorizacion: token })
    })
    .then(function(response) {
      if (response.data && response.data.length > 0) {
        this.setState({ notificaciones: response.data });
      }
    }.bind(this))
    .catch(function() {});
  }

  marcarNotificacionLeida = (dni) => {
    var token = this.getToken();
    axios.post(API_URL + '/notificaciones/marcarleida/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ dni_trabajador: dni, autorizacion: token })
    })
    .then(function() {
      this.setState({ notificaciones: this.state.notificaciones.filter(function(n) { return n.dni_trabajador !== dni; }) });
    }.bind(this))
    .catch(function() {});
  }

  procederConNotificacion = (notif) => {
    var token = this.getToken();
    var dni = notif.DniTrabajador;
    // Marcar como leída
    this.marcarNotificacionLeida(dni);
    // Limpiar estado actual
    this.setState({
      dniBusqueda: dni, dniConfirmado: '', consultado: false, cargando: true, mensajeError: '',
      datosPersonales: [], condicionesLaborales: [], planillas: [], periodos: [], boletapdf: [],
      planillaSeleccionada: '', periodoSeleccionado: '', datosPersonalesPeriodo: [], planillasTrabajador: [],
      otrasPeriodos: [], otrasPeriodoSel: '', otrasPlanillasDisp: [], otrasPlanillaSel: '',
      otrasBoletapdf: [], otrasDatosPersonales: [], otrasPlanillasTrab: [], usuario: '',
      compTipo: 'COMPROBANTE', compExpediente: '', compTrabajadoresExpediente: 0,
      compSerie: '', compNumero: '', compMonto: '', compRegistrado: null,
      compDescargasPermitidas: 0, compDescargasRealizadas: 0, compMensaje: '', compError: ''
    });

    var miInit = {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token, 'usuario': dni }
    };

    // Consultar datos del trabajador
    Promise.all([
      fetch(API_URL + '/vinculopdf/', miInit).then(function(r) { return r.text(); }),
      fetch(API_URL + '/condicionlaboralhistorico/', miInit).then(function(r) { return r.text(); })
    ])
    .then(function(results) {
      var data1 = []; var data2 = [];
      try { if (results[0] && results[0].length > 2) data1 = JSON.parse(results[0]); } catch(e) {}
      try { if (results[1] && results[1].length > 2) data2 = JSON.parse(results[1]); } catch(e) {}
      var tieneNombre = data1 && data1.length > 0 && data1.some(function(d) { return d.nombre && d.nombre.trim() !== ''; });
      if (tieneNombre) {
        // Cargar comprobante activo de ese DNI
        axios.post(API_URL + '/obtenercomprobantes/', {
          method: 'post', credentials: 'same-origin', mode: 'cors',
          headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
          body: JSON.stringify({ dni_trabajador: dni, autorizacion: token })
        })
        .then(function(resComp) {
          var comp = null;
          if (resComp.data && resComp.data.length > 0) {
            // Buscar el comprobante de la notificación
            for (var i = 0; i < resComp.data.length; i++) {
              if (resComp.data[i].IdComprobante === notif.IdComprobante) {
                comp = resComp.data[i];
                break;
              }
            }
            if (!comp) comp = resComp.data[0];
          }
          if (comp) {
            // 11/08/2026 - un expediente no se parte en serie y numero: su
            // numero completo va tal cual, y no tiene monto ni restantes.
            var esExpAbierto = comp.TipoDocumento === 'EXPEDIENTE';
            var partes = (comp.SerieNumero || '').split('-');
            var serie = esExpAbierto ? '' : (partes[0] || '');
            var numero = esExpAbierto ? '' : (partes.slice(1).join('-') || '');
            this.setState({
              datosPersonales: data1, condicionesLaborales: data2,
              dniConfirmado: dni, consultado: true, usuario: dni, autorizacion: token, cargando: false,
              compTipo: esExpAbierto ? 'EXPEDIENTE' : 'COMPROBANTE',
              compExpediente: esExpAbierto ? comp.SerieNumero : '',
              compSerie: serie, compNumero: numero,
              compMonto: esExpAbierto ? '' : String(comp.MontoPagado),
              compRegistrado: comp,
              compDescargasPermitidas: comp.CantidadBoletas,
              compDescargasRealizadas: comp.DescargasRealizadas,
              compMensaje: esExpAbierto
                ? 'Expediente activo. Entregadas: ' + comp.DescargasRealizadas + ' (sin tope)'
                : 'Comprobante con extras activo. Restantes: ' + (comp.CantidadBoletas - comp.DescargasRealizadas)
            });
          } else {
            this.setState({
              datosPersonales: data1, condicionesLaborales: data2,
              dniConfirmado: dni, consultado: true, usuario: dni, autorizacion: token, cargando: false
            });
          }
        }.bind(this))
        .catch(function() {
          this.setState({
            datosPersonales: data1, condicionesLaborales: data2,
            dniConfirmado: dni, consultado: true, usuario: dni, autorizacion: token, cargando: false
          });
        }.bind(this));
      } else {
        this.setState({ cargando: false, mensajeError: 'No se encontraron datos para el DNI' });
      }
    }.bind(this))
    .catch(function() { this.setState({ cargando: false, mensajeError: 'Error al consultar' }); }.bind(this));
  }

  scrollToSelected = (selectedLabel) => {
    if (!selectedLabel) return;
    var intentos = 0;
    var fn = function() {
      intentos++;
      var options = document.querySelectorAll('[class*="-option"]');
      if ((!options || options.length === 0) && intentos < 15) { setTimeout(fn, 40); return; }
      for (var i = 0; i < options.length; i++) {
        if (options[i].textContent === selectedLabel) {
          var menuEl = options[i].parentElement;
          if (menuEl) {
            menuEl.scrollTop = options[i].offsetTop - menuEl.clientHeight / 2 + options[i].clientHeight / 2;
          }
          break;
        }
      }
    };
    setTimeout(fn, 50);
  }

  // 11/08/2026 - El modo de esta pantalla ya no sale de una cadena "rol"
  // guardada en la sesion, sino de la ruta y de los modulos que concede el rol:
  //
  //   /admin-boletas-comprobante -> hay que registrar comprobante  ("OPERADOR")
  //   /admin-boletas             -> descarga directa               ("ADMIN")
  //
  // Quien solo tenga BOLETAS_COMPROBANTE queda siempre en el flujo con
  // comprobante, entre por la ruta que entre. Se conservan los mismos dos
  // valores de retorno para no tener que tocar el resto del componente.
  getRol = () => {
    var datos = obtenerDatosSesion(this.props);
    if (!datos) return "";

    var ruta = (this.props.location && this.props.location.pathname) || "";
    var enRutaComprobante = ruta.indexOf('/admin-boletas-comprobante') === 0;
    var soloComprobante = puede(datos, 'BOLETAS_COMPROBANTE') && !puede(datos, 'BOLETAS_ADMIN');

    if (enRutaComprobante || soloComprobante) return 'OPERADOR';
    if (puede(datos, 'BOLETAS_ADMIN')) return 'ADMIN';
    return "";
  }

  // Si el usuario tiene mas de un modulo, el boton "Volver" lo devuelve al
  // panel. Un operador con una sola pantalla no tiene panel al que volver.
  tienePanel = () => {
    var datos = obtenerDatosSesion(this.props);
    if (!datos) return false;
    var modulos = obtenerModulos(datos);
    return Object.keys(modulos).length > 1;
  }

  getToken = () => {
    let datos = this.props.location.state ? this.props.location.state.datos : null;
    if (!datos) { try { datos = JSON.parse(sessionStorage.getItem('datos')); } catch(e) { datos = null; } }
    return datos && datos[0] ? datos[0].autorizacion : "";
  }

  // ¿El documento con el que se está trabajando es un expediente?
  // El expediente no tiene tope: no se compara contra compDescargasPermitidas.
  esExpediente = () => {
    return !!(this.state.compRegistrado &&
              this.state.compRegistrado.TipoDocumento === 'EXPEDIENTE');
  }

  // Texto del saldo. Un comprobante muestra cuántas le quedan; un expediente
  // no tiene saldo que mostrar, solo cuántas lleva entregadas.
  textoSaldo = () => {
    if (this.esExpediente()) return 'Sin límite';
    return String(this.state.compDescargasPermitidas - this.state.compDescargasRealizadas);
  }

  // 11/08/2026 - una sola función para los dos orígenes. Va al mismo endpoint
  // y a la misma tabla; lo único que cambia es qué campos se envían.
  handleRegistrarComprobante = () => {
    var esExp = this.state.compTipo === 'EXPEDIENTE';
    var dni = this.state.dniConfirmado;
    if (!dni) { this.setState({ compError: 'Primero consulte un DNI' }); return; }

    var numeroDocumento, monto;

    if (esExp) {
      numeroDocumento = this.state.compExpediente.trim();
      if (!numeroDocumento) { this.setState({ compError: 'Indique el número de expediente' }); return; }
      monto = 0;
    } else {
      var serie = this.state.compSerie.trim();
      var numero = this.state.compNumero.trim();
      var montoTexto = this.state.compMonto.trim();
      if (!serie || !numero || !montoTexto) { this.setState({ compError: 'Complete todos los campos del comprobante' }); return; }
      if (isNaN(parseFloat(montoTexto)) || parseFloat(montoTexto) < 3) { this.setState({ compError: 'El monto mínimo es S/ 3.00' }); return; }
      numeroDocumento = serie + '-' + numero;
      monto = parseFloat(montoTexto);
    }

    var token = this.getToken();
    this.setState({ compError: '', compMensaje: '' });
    axios.post(API_URL + '/registrarcomprobante/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({
        serie_numero: numeroDocumento,
        dni_trabajador: dni,
        monto_pagado: monto,
        tipo_documento: esExp ? 'EXPEDIENTE' : 'COMPROBANTE',
        autorizacion: token
      })
    })
    .then(function(response) {
      if (response.data && response.data.length > 0) {
        var comp = response.data[0];
        if (comp.Resultado === 'ERROR') {
          var msgError = comp.Mensaje;
          if (comp.Mensaje === 'El comprobante ya fue registrado') {
            msgError = 'Comprobante duplicado: el número ' + numeroDocumento + ' ya existe.';
          } else if (comp.Mensaje === 'Este trabajador ya esta registrado en ese expediente') {
            // 13/08/2026 - Ya no es un choque por el número de expediente: el
            // mismo expediente puede cubrir a varios trabajadores. Solo choca
            // si se intenta registrar dos veces a la misma persona.
            msgError = 'Este trabajador ya está registrado en el expediente ' + numeroDocumento +
                       '. Búsquelo de nuevo y continúe con el expediente abierto.';
          }
          this.setState({ compError: msgError });
          return;
        }

        if (esExp) {
          // El procedimiento devuelve cuántos trabajadores lleva ya el
          // expediente. Sirve de confirmación cuando la solicitud cubre a
          // varias personas: se ve que se está sumando a la correcta.
          var cuantos = comp.TrabajadoresEnExpediente;
          var avisoExp = 'Expediente registrado. Las descargas quedan registradas, sin tope.';
          if (cuantos > 1) {
            avisoExp = 'Trabajador añadido al expediente ' + numeroDocumento +
                       '. Van ' + cuantos + ' trabajadores en esta solicitud.';
          }
          this.setState({
            compRegistrado: { IdComprobante: comp.IdComprobante, TipoDocumento: 'EXPEDIENTE' },
            compExpediente: numeroDocumento,
            compTrabajadoresExpediente: cuantos || 1,
            compDescargasPermitidas: 0,
            compDescargasRealizadas: 0,
            compMensaje: avisoExp
          });
          return;
        }

        var cantBoletas = comp.CantidadBoletas || Math.floor(monto / 3);
        this.setState({
          compRegistrado: comp,
          compDescargasPermitidas: cantBoletas,
          compDescargasRealizadas: 0,
          compMensaje: 'Comprobante registrado. Descargas permitidas: ' + cantBoletas
        });
      } else {
        this.setState({ compError: 'No se obtuvo respuesta del servidor' });
      }
    }.bind(this))
    .catch(function(err) {
      this.setState({ compError: esExp ? 'Error al registrar expediente' : 'Error al registrar comprobante' });
      console.error(err);
    }.bind(this));
  }

  // 11/08/2026 - Búsqueda de trabajador por DNI o por nombre.
  //
  // Antes el campo solo aceptaba el DNI exacto de 8 dígitos: si el trabajador
  // no lo recordaba, no se le podía atender. Ahora el mismo campo admite las
  // dos cosas y la lista de abajo se va filtrando mientras se escribe.
  //
  // Se buscan todas las palabras a la vez, sin importar el orden ni si son
  // nombre o apellido: "PEREZ ROXANA" y "ROXANA PEREZ" dan lo mismo.
  //
  // El filtro va contra el servidor con 300 ms de espera desde la última
  // tecla, en vez de traerse las 6,930 personas al navegador. En la red de
  // la oficina la consulta tarda entre 30 y 270 ms, así que se siente
  // inmediato y no hay que cargar medio megabyte en cada visita.
  buscarTrabajadores = (texto) => {
    var token = this.getToken();
    this.setState({ buscandoTrabajador: true });

    axios.post(API_URL + '/buscartrabajador/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ texto: texto || '', autorizacion: token })
    })
    .then(function(resp) {
      // Puede llegar tarde una respuesta de un texto ya descartado.
      if ((texto || '') !== (this.state.dniBusqueda || '').trim()) return;
      this.setState({ buscandoTrabajador: false, resultadosBusqueda: resp.data || [] });
    }.bind(this))
    .catch(function(err) {
      console.error(err);
      this.setState({ buscandoTrabajador: false, resultadosBusqueda: [] });
    }.bind(this));
  }

  // Se reprograma en cada tecla: solo se consulta cuando deja de escribir.
  alEscribirBusqueda = (valor) => {
    this.setState({ dniBusqueda: valor, mensajeError: '' });
    if (this.temporizadorBusqueda) clearTimeout(this.temporizadorBusqueda);
    this.temporizadorBusqueda = setTimeout(function() {
      this.buscarTrabajadores(valor.trim());
    }.bind(this), 300);
  }

  seleccionarTrabajador = (dni) => {
    this.setState({ dniBusqueda: dni });
    this.consultarPorDni(dni);
  }

  // Enter o botón Consultar. Con un DNI completo entra directo; si no, se
  // apoya en la lista de abajo.
  handleConsultar = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    const texto = this.state.dniBusqueda.trim();
    if (!texto) return;

    if (/^\d{8}$/.test(texto)) {
      this.consultarPorDni(texto);
      return;
    }
    // Con una sola coincidencia en la lista no tiene sentido hacerle elegir.
    if (this.state.resultadosBusqueda.length === 1) {
      this.seleccionarTrabajador(this.state.resultadosBusqueda[0].DNI);
      return;
    }
    if (this.state.resultadosBusqueda.length === 0) {
      this.setState({ mensajeError: 'No se encontró ningún trabajador con "' + texto + '"' });
      return;
    }
    this.setState({ mensajeError: 'Hay varias coincidencias: elija una de la lista' });
  }

  consultarPorDni = (dniConsulta) => {
    const dni = (dniConsulta || '').trim();
    if (dni.length < 8) return;

    const token = this.getToken();
    this.setState({ cargando: true, consultado: false, mensajeError: '', datosPersonales: [], condicionesLaborales: [], planillas: [], periodos: [], boletapdf: [], planillaSeleccionada: "", periodoSeleccionado: "", datosPersonalesPeriodo: [], planillasTrabajador: [], otrasPeriodos: [], otrasPeriodoSel: '', otrasPlanillasDisp: [], otrasPlanillaSel: '', otrasBoletapdf: [], otrasDatosPersonales: [], otrasPlanillasTrab: [], usuario: '' });

    const miInit = {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token, 'usuario': dni }
    };

    Promise.all([
      fetch(API_URL + '/vinculopdf/', miInit).then(r => r.text()),
      fetch(API_URL + '/condicionlaboralhistorico/', miInit).then(r => r.text())
    ])
    .then(([text1, text2]) => {
      var data1 = []; var data2 = [];
      try { if (text1 && text1.length > 2) data1 = JSON.parse(text1); } catch(e) {}
      try { if (text2 && text2.length > 2) data2 = JSON.parse(text2); } catch(e) {}
      var tieneNombre = data1 && data1.length > 0 && data1.some(function(d) { return d.nombre && d.nombre.trim() !== ""; });
      if (tieneNombre) {
        var rol = this.getRol();
        if (rol === 'OPERADOR') {
          this.marcarNotificacionLeida(dni);
          this.consultarNotificaciones();
          // Verificar si hay comprobante activo con descargas pendientes
          axios.post(API_URL + '/obtenercomprobantes/', {
            method: 'post', credentials: 'same-origin', mode: 'cors',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
            body: JSON.stringify({ dni_trabajador: dni, autorizacion: token })
          })
          .then(function(resComp) {
            var compActivo = null;
            if (resComp.data && resComp.data.length > 0) {
              for (var i = 0; i < resComp.data.length; i++) {
                var c = resComp.data[i];
                // Un expediente siempre está disponible: no tiene saldo que
                // restar. Con la resta a secas (0 - N) nunca daría > 0 y no se
                // ofrecería continuar con él.
                if (c.TipoDocumento === 'EXPEDIENTE') { compActivo = c; break; }
                if ((c.CantidadBoletas - c.DescargasRealizadas) > 0) { compActivo = c; break; }
              }
            }
            if (compActivo) {
              this.setState({
                datosPersonalesTemp: data1, condicionesLaboralesTemp: data2,
                compPendienteData: compActivo, modalCompPendiente: true, cargando: false
              });
            } else {
              this.setState({ datosPersonales: data1, condicionesLaborales: data2, dniConfirmado: dni, consultado: true, usuario: dni, autorizacion: token, cargando: false });
            }
          }.bind(this))
          .catch(function() {
            this.setState({ datosPersonales: data1, condicionesLaborales: data2, dniConfirmado: dni, consultado: true, usuario: dni, autorizacion: token, cargando: false });
          }.bind(this));
        } else {
          this.setState({ datosPersonales: data1, condicionesLaborales: data2, dniConfirmado: dni, consultado: true, usuario: dni, autorizacion: token, cargando: false });
        }
      } else {
        this.setState({ cargando: false, consultado: false });
        this.setState({ mensajeError: "No se encontraron datos para el DNI ingresado" });
      }
    })
    .catch(() => { this.setState({ cargando: false, consultado: false }); this.setState({ mensajeError: "No se encontraron datos para el DNI ingresado" }); });
  }

  continuarConComprobanteExistente = () => {
    var comp = this.state.compPendienteData;
    var esExpAbierto = comp.TipoDocumento === 'EXPEDIENTE';
    var partes = (comp.SerieNumero || '').split('-');
    var serie = esExpAbierto ? '' : (partes[0] || '');
    var numero = esExpAbierto ? '' : (partes.slice(1).join('-') || '');
    var dni = this.state.dniBusqueda.trim();
    this.setState({
      datosPersonales: this.state.datosPersonalesTemp,
      condicionesLaborales: this.state.condicionesLaboralesTemp,
      dniConfirmado: dni, consultado: true, usuario: dni, autorizacion: this.getToken(),
      compTipo: esExpAbierto ? 'EXPEDIENTE' : 'COMPROBANTE',
      compExpediente: esExpAbierto ? comp.SerieNumero : '',
      compSerie: serie, compNumero: numero,
      compMonto: esExpAbierto ? '' : String(comp.MontoPagado),
      compRegistrado: comp,
      compDescargasPermitidas: comp.CantidadBoletas,
      compDescargasRealizadas: comp.DescargasRealizadas,
      compMensaje: esExpAbierto
        ? 'Expediente retomado. Entregadas: ' + comp.DescargasRealizadas + ' (sin tope)'
        : 'Comprobante retomado. Descargas restantes: ' + (comp.CantidadBoletas - comp.DescargasRealizadas),
      modalCompPendiente: false, compPendienteData: null,
      datosPersonalesTemp: [], condicionesLaboralesTemp: []
    });
  }

  continuarSinComprobanteExistente = () => {
    var dni = this.state.dniBusqueda.trim();
    this.setState({
      datosPersonales: this.state.datosPersonalesTemp,
      condicionesLaborales: this.state.condicionesLaboralesTemp,
      dniConfirmado: dni, consultado: true, usuario: dni, autorizacion: this.getToken(),
      modalCompPendiente: false, compPendienteData: null,
      datosPersonalesTemp: [], condicionesLaboralesTemp: []
    });
  }

  // Al seleccionar condición laboral → cargar últimos 6 periodos
  handleCondicionChange = (e) => {
    const trabajador = e.target.value.trim();
    if (!trabajador) return;
    const token = this.getToken();

    this.setState({ usuario: trabajador, periodos: [], planillas: [], boletapdf: [], periodoSeleccionado: "", planillaSeleccionada: "", datosPersonalesPeriodo: [], planillasTrabajador: [] });

    fetch(API_URL + '/todoslosperiodos/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token, 'usuario': trabajador }
    })
    .then(res => res.text())
    .then(text => {
      let data = [];
      try { if (text && text.length > 2) data = JSON.parse(text); } catch(e) {}
      if (data && data.length > 0) this.setState({ periodos: data, otrasPeriodos: data });
    })
    .catch(err => console.error(err));
  }

  // Al seleccionar periodo → cargar planillas remunerativas del trabajador en ese periodo
  handlePeriodoChange = (e) => {
    const periodo = e.target.value;
    if (!periodo) { this.setState({ periodoSeleccionado: "", planillas: [], planillaSeleccionada: "", boletapdf: [], datosPersonalesPeriodo: [], planillasTrabajador: [] }); return; }
    const token = this.getToken();
    const planillaAnterior = this.state.planillaSeleccionada;

    this.setState({ periodoSeleccionado: periodo, planillas: [], boletapdf: [], datosPersonalesPeriodo: [], planillasTrabajador: [] });

    axios.post(API_URL + '/planillastrabajadorperiodo/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ periodo: periodo, usuario: this.state.usuario, autorizacion: token })
    })
    .then(response => {
      if (response.data && response.data.length > 0) {
        const remunerativas = ['DOC','DOA','CAS','ADA','ACO','CEA','BON','CAF','EEE','JND','PDP','ADC','ADV','CDO','DOV'];
        const filtradas = response.data.filter(s => s.value && remunerativas.includes(s.value));
        this.setState({ planillas: filtradas, planillasTrabajador: response.data });
        // Si la planilla anterior existe en este periodo, seleccionarla automáticamente
        if (planillaAnterior && filtradas.some(s => s.value === planillaAnterior)) {
          this.setState({ planillaSeleccionada: planillaAnterior });
          // Cargar boleta automáticamente
          axios.post(API_URL + '/boletapdf/', {
            method: 'post', credentials: 'same-origin', mode: 'cors',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
            body: JSON.stringify({ usuario: this.state.usuario, periodo: periodo, tipoplanilla: planillaAnterior })
          })
          .then(res2 => { if (res2.data && res2.data.length > 0) this.setState({ boletapdf: res2.data }); })
          .catch(err => console.error(err));
          axios.post(API_URL + '/vinculopdfuno/', {
            method: 'post', credentials: 'same-origin', mode: 'cors',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
            body: JSON.stringify({ usuario: this.state.usuario })
          })
          .then(res3 => { if (res3.data && res3.data.length > 0) this.setState({ datosPersonalesPeriodo: res3.data }); })
          .catch(err => console.error(err));
        } else {
          this.setState({ planillaSeleccionada: "" });
        }
      }
    })
    .catch(err => console.error(err));
  }

  // Al seleccionar planilla → cargar boleta y datos personales
  handlePlanillaChange = (opt) => {
    const tipoplanilla = opt ? opt.value : '';
    if (!tipoplanilla) { this.setState({ planillaSeleccionada: "", boletapdf: [], datosPersonalesPeriodo: [] }); return; }

    this.setState({ planillaSeleccionada: tipoplanilla, boletapdf: [], datosPersonalesPeriodo: [] });

    axios.post(API_URL + '/boletapdf/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ usuario: this.state.usuario, periodo: this.state.periodoSeleccionado, tipoplanilla: tipoplanilla })
    })
    .then(response => { if (response.data && response.data.length > 0) this.setState({ boletapdf: response.data }); })
    .catch(err => console.error(err));

    axios.post(API_URL + '/vinculopdfuno/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ usuario: this.state.usuario })
    })
    .then(response => { if (response.data && response.data.length > 0) this.setState({ datosPersonalesPeriodo: response.data }); })
    .catch(err => console.error(err));
  }

  ejecutarNuevaBusqueda = () => {
    let datos = this.props.location.state ? this.props.location.state.datos : null;
    if (datos) sessionStorage.setItem('datos', JSON.stringify(datos));
    this.setState({ dniBusqueda: "", dniConfirmado: "", consultado: false, datosPersonales: [], condicionesLaborales: [], planillas: [], periodos: [], boletapdf: [], planillaSeleccionada: "", periodoSeleccionado: "", datosPersonalesPeriodo: [], planillasTrabajador: [], otrasPeriodos: [], otrasPeriodoSel: '', otrasPlanillasDisp: [], otrasPlanillaSel: '', otrasBoletapdf: [], otrasDatosPersonales: [], otrasPlanillasTrab: [], usuario: '', compTipo: 'COMPROBANTE', compExpediente: '', compTrabajadoresExpediente: 0, compSerie: '', compNumero: '', compMonto: '', compRegistrado: null, compDescargasPermitidas: 0, compDescargasRealizadas: 0, compMensaje: '', compError: '', mostrarConfirmacion: false, modalCompPendiente: false, compPendienteData: null, datosPersonalesTemp: [], condicionesLaboralesTemp: [], verificandoDescarga: false });
    // Se repuebla la lista de abajo, que vuelve a quedar a la vista.
    this.buscarTrabajadores('');
  }

  handleNuevaBusqueda = () => {
    var rol = this.getRol();
    if (rol === 'OPERADOR' && this.state.consultado && this.state.compRegistrado) {
      this.setState({ mostrarConfirmacion: true });
      return;
    }
    this.ejecutarNuevaBusqueda();
  }

  handleDniFocus = () => {
    var rol = this.getRol();
    if (rol === 'OPERADOR' && this.state.consultado && this.state.compRegistrado) {
      this.setState({ mostrarConfirmacion: true });
    }
  }


  // === OTRAS PLANILLAS: Al cargar periodos (todos) ===
  cargarOtrasPeriodos = () => {
    const token = this.getToken();
    fetch(API_URL + '/todoslosperiodos/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'authorization': token, 'usuario': this.state.usuario }
    })
    .then(res => res.json())
    .then(data => { if (data && data.length > 0) this.setState({ otrasPeriodos: data }); })
    .catch(err => console.error(err));
  }

  // === OTRAS PLANILLAS: Al seleccionar periodo -> cargar planillas no remunerativas ===
  handleOtrasPeriodoChange = (e) => {
    const periodo = e.target.value;
    if (!periodo) { this.setState({ otrasPeriodoSel: '', otrasPlanillasDisp: [], otrasPlanillaSel: '', otrasBoletapdf: [], otrasDatosPersonales: [], otrasPlanillasTrab: [] }); return; }
    const token = this.getToken();
    const planillaAnterior = this.state.otrasPlanillaSel;

    this.setState({ otrasPeriodoSel: periodo, otrasPlanillasDisp: [], otrasBoletapdf: [], otrasDatosPersonales: [], otrasPlanillasTrab: [] });

    axios.post(API_URL + '/planillastrabajadorperiodo/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ periodo: periodo, usuario: this.state.usuario, autorizacion: token })
    })
    .then(response => {
      if (response.data && response.data.length > 0) {
        const remunerativas = ['DOC','DOA','CAS','ADA','ACO','CEA','BON','CAF','EEE','JND','PDP','ADC','ADV','CDO','DOV'];
        const otras = response.data.filter(s => s.value && !remunerativas.includes(s.value));
        this.setState({ otrasPlanillasDisp: otras });
        // Si la planilla anterior existe en este periodo, seleccionarla automáticamente
        if (planillaAnterior && otras.some(s => s.value === planillaAnterior)) {
          this.setState({ otrasPlanillaSel: planillaAnterior });
          var scrollBack = () => { setTimeout(() => { if (this.refOtrasCard.current) this.refOtrasCard.current.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 200); };
          axios.post(API_URL + '/boletapdf/', {
            method: 'post', credentials: 'same-origin', mode: 'cors',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
            body: JSON.stringify({ usuario: this.state.usuario, periodo: periodo, tipoplanilla: planillaAnterior })
          })
          .then(res2 => { if (res2.data && res2.data.length > 0) { this.setState({ otrasBoletapdf: res2.data }); scrollBack(); } })
          .catch(err => console.error(err));
          axios.post(API_URL + '/vinculopdfuno/', {
            method: 'post', credentials: 'same-origin', mode: 'cors',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
            body: JSON.stringify({ usuario: this.state.usuario })
          })
          .then(res3 => { if (res3.data && res3.data.length > 0) this.setState({ otrasDatosPersonales: res3.data }); })
          .catch(err => console.error(err));
          axios.post(API_URL + '/planillastrabajadorperiodo/', {
            method: 'post', credentials: 'same-origin', mode: 'cors',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
            body: JSON.stringify({ periodo: periodo, usuario: this.state.usuario, autorizacion: token })
          })
          .then(res4 => { if (res4.data && res4.data.length > 0) this.setState({ otrasPlanillasTrab: res4.data }); })
          .catch(err => console.error(err));
        } else {
          this.setState({ otrasPlanillaSel: '' });
        }
      }
    })
    .catch(err => console.error(err));
  }

  // === OTRAS PLANILLAS: Al seleccionar planilla -> cargar boleta ===
  handleOtrasPlanillaChange = (opt) => {
    const tipoplanilla = opt ? opt.value : '';
    if (!tipoplanilla) { this.setState({ otrasPlanillaSel: '', otrasBoletapdf: [] }); return; }
    const token = this.getToken();
    this.setState({ otrasPlanillaSel: tipoplanilla, otrasBoletapdf: [] });
    axios.post(API_URL + '/boletapdf/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ usuario: this.state.usuario, periodo: this.state.otrasPeriodoSel, tipoplanilla: tipoplanilla })
    })
    .then(response => { if (response.data && response.data.length > 0) this.setState({ otrasBoletapdf: response.data }); })
    .catch(err => console.error(err));
    axios.post(API_URL + '/vinculopdfuno/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ usuario: this.state.usuario })
    })
    .then(response => { if (response.data && response.data.length > 0) this.setState({ otrasDatosPersonales: response.data }); })
    .catch(err => console.error(err));
    axios.post(API_URL + '/planillastrabajadorperiodo/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ periodo: this.state.otrasPeriodoSel, usuario: this.state.usuario, autorizacion: token })
    })
    .then(response => { if (response.data && response.data.length > 0) this.setState({ otrasPlanillasTrab: response.data }); })
    .catch(err => console.error(err));
  }

  // === OTRAS PLANILLAS: Descargar PDF ===
  descargarOtrasPDF = () => {
    if (this.state.otrasBoletapdf.length === 0) return;
    generarBoletaPDF(
      this.state.otrasBoletapdf,
      this.state.otrasDatosPersonales,
      this.state.otrasPlanillasTrab,
      this.state.otrasPeriodoSel,
      this.state.otrasPlanillaSel
    );
  }

  // Generar PDF con validación backend secuencial
  descargarPDF = () => {
    if (this.state.boletapdf.length === 0) return;
    var rol = this.getRol();
    // ADMIN: descarga directa sin comprobante
    if (rol !== 'OPERADOR') {
      generarBoletaPDF(this.state.boletapdf, this.state.datosPersonalesPeriodo, this.state.planillasTrabajador, this.state.periodoSeleccionado, this.state.planillaSeleccionada);
      return;
    }
    // OPERADOR: validar → registrar → generar
    if (!this.state.compRegistrado) { this.setState({ compError: 'Debe registrar un comprobante o expediente antes de descargar' }); return; }
    // El expediente no tiene tope, asi que esta comprobacion no le aplica.
    if (!this.esExpediente() && this.state.compDescargasRealizadas >= this.state.compDescargasPermitidas) { this.setState({ compError: 'Ya alcanzó el límite de descargas permitidas' }); return; }
    if (this.state.verificandoDescarga) return;
    var token = this.getToken();
    this.setState({ verificandoDescarga: true, compError: '', compMensaje: '' });
    // Paso 1: Validar saldo en BD
    axios.post(API_URL + '/validardescarga/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ id_comprobante: this.state.compRegistrado.IdComprobante, dni_trabajador: this.state.dniConfirmado, autorizacion: token })
    })
    .then(function(resVal) {
      var data = resVal.data;
      var puede = false;
      if (data && data.length > 0) {
        var v = data[0];
        var esError = (v.Resultado === 'ERROR') || (v.Resultado !== undefined && v.Resultado !== 'OK');
        // En un expediente el procedimiento devuelve DescargasRestantes = null,
        // que ya se interpreta aqui como "no hay saldo que agotar".
        var sinSaldo = (v.DescargasRestantes !== undefined && v.DescargasRestantes !== null && parseInt(v.DescargasRestantes) <= 0);
        puede = !esError && !sinSaldo;
        // Sincronizar contador si el SP devuelve restantes reales
        if (v.restantes !== undefined && v.restantes !== null) {
          var realizadasReal = this.state.compDescargasPermitidas - parseInt(v.restantes);
          if (realizadasReal > this.state.compDescargasRealizadas) {
            this.setState({ compDescargasRealizadas: realizadasReal });
          }
        }
      }
      if (!puede) {
        this.setState({ verificandoDescarga: false, compError: 'Sin descargas disponibles. Verifique el saldo del comprobante.' });
        return;
      }
      // Paso 2: Registrar la descarga en BD
      axios.post(API_URL + '/registrardescarga/', {
        method: 'post', credentials: 'same-origin', mode: 'cors',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
        body: JSON.stringify({ id_comprobante: this.state.compRegistrado.IdComprobante, dni_trabajador: this.state.dniConfirmado, periodo: this.state.periodoSeleccionado, tipo_planilla: this.state.planillaSeleccionada, autorizacion: token })
      })
      .then(function(resReg) {
        var dataReg = resReg.data;
        if (dataReg && dataReg.length > 0 && dataReg[0].Resultado === 'ERROR') {
          this.setState({ verificandoDescarga: false, compError: dataReg[0].Mensaje || 'Error al registrar la descarga' });
          return;
        }
        // Actualizar contador desde BD si el SP lo devuelve, si no +1
        var nuevasRealizadas = this.state.compDescargasRealizadas + 1;
        if (dataReg && dataReg.length > 0 && dataReg[0].DescargasRealizadas !== undefined && dataReg[0].DescargasRealizadas !== null) {
          nuevasRealizadas = parseInt(dataReg[0].DescargasRealizadas);
        }
        var avisoSaldo = this.esExpediente()
          ? 'Descarga registrada en el expediente. Entregadas: ' + nuevasRealizadas
          : 'Descarga registrada. Restantes: ' + (this.state.compDescargasPermitidas - nuevasRealizadas);
        this.setState({ verificandoDescarga: false, compDescargasRealizadas: nuevasRealizadas, compMensaje: avisoSaldo });
        // Paso 3: Generar PDF solo después de confirmar el registro
        generarBoletaPDF(this.state.boletapdf, this.state.datosPersonalesPeriodo, this.state.planillasTrabajador, this.state.periodoSeleccionado, this.state.planillaSeleccionada);
      }.bind(this))
      .catch(function(err) {
        console.error(err);
        this.setState({ verificandoDescarga: false, compError: 'Error al registrar la descarga. Intente nuevamente.' });
      }.bind(this));
    }.bind(this))
    .catch(function(err) {
      console.error(err);
      this.setState({ verificandoDescarga: false, compError: 'Error al verificar disponibilidad. Intente nuevamente.' });
    }.bind(this));
  }

  descargarOtrasPDFConControl = () => {
    if (this.state.otrasBoletapdf.length === 0) return;
    var rol = this.getRol();
    // ADMIN: descarga directa
    if (rol !== 'OPERADOR') { this.descargarOtrasPDF(); return; }
    // OPERADOR: validar → registrar → generar
    if (!this.state.compRegistrado) { this.setState({ compError: 'Debe registrar un comprobante o expediente antes de descargar' }); return; }
    if (!this.esExpediente() && this.state.compDescargasRealizadas >= this.state.compDescargasPermitidas) { this.setState({ compError: 'Ya alcanzó el límite de descargas permitidas' }); return; }
    if (this.state.verificandoDescarga) return;
    var token = this.getToken();
    this.setState({ verificandoDescarga: true, compError: '', compMensaje: '' });
    // Paso 1: Validar saldo en BD
    axios.post(API_URL + '/validardescarga/', {
      method: 'post', credentials: 'same-origin', mode: 'cors',
      headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
      body: JSON.stringify({ id_comprobante: this.state.compRegistrado.IdComprobante, dni_trabajador: this.state.dniConfirmado, autorizacion: token })
    })
    .then(function(resVal) {
      var data = resVal.data;
      var puede = false;
      if (data && data.length > 0) {
        var v = data[0];
        var esError = (v.Resultado === 'ERROR') || (v.Resultado !== undefined && v.Resultado !== 'OK');
        var sinSaldo = (v.DescargasRestantes !== undefined && v.DescargasRestantes !== null && parseInt(v.DescargasRestantes) <= 0);
        puede = !esError && !sinSaldo;
        if (v.restantes !== undefined && v.restantes !== null) {
          var realizadasReal = this.state.compDescargasPermitidas - parseInt(v.restantes);
          if (realizadasReal > this.state.compDescargasRealizadas) {
            this.setState({ compDescargasRealizadas: realizadasReal });
          }
        }
      }
      if (!puede) {
        this.setState({ verificandoDescarga: false, compError: 'Sin descargas disponibles. Verifique el saldo del comprobante.' });
        return;
      }
      // Paso 2: Registrar la descarga
      axios.post(API_URL + '/registrardescarga/', {
        method: 'post', credentials: 'same-origin', mode: 'cors',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json', 'Content-Type': 'application/json', 'Authorization': '99999' },
        body: JSON.stringify({ id_comprobante: this.state.compRegistrado.IdComprobante, dni_trabajador: this.state.dniConfirmado, periodo: this.state.otrasPeriodoSel, tipo_planilla: this.state.otrasPlanillaSel, autorizacion: token })
      })
      .then(function(resReg) {
        var dataReg = resReg.data;
        if (dataReg && dataReg.length > 0 && dataReg[0].Resultado === 'ERROR') {
          this.setState({ verificandoDescarga: false, compError: dataReg[0].Mensaje || 'Error al registrar la descarga' });
          return;
        }
        var nuevasRealizadas = this.state.compDescargasRealizadas + 1;
        if (dataReg && dataReg.length > 0 && dataReg[0].DescargasRealizadas !== undefined && dataReg[0].DescargasRealizadas !== null) {
          nuevasRealizadas = parseInt(dataReg[0].DescargasRealizadas);
        }
        var avisoSaldoOtras = this.esExpediente()
          ? 'Descarga registrada en el expediente. Entregadas: ' + nuevasRealizadas
          : 'Descarga registrada. Restantes: ' + (this.state.compDescargasPermitidas - nuevasRealizadas);
        this.setState({ verificandoDescarga: false, compDescargasRealizadas: nuevasRealizadas, compMensaje: avisoSaldoOtras });
        // Paso 3: Generar PDF
        generarBoletaPDF(this.state.otrasBoletapdf, this.state.otrasDatosPersonales, this.state.otrasPlanillasTrab, this.state.otrasPeriodoSel, this.state.otrasPlanillaSel);
      }.bind(this))
      .catch(function(err) {
        console.error(err);
        this.setState({ verificandoDescarga: false, compError: 'Error al registrar la descarga. Intente nuevamente.' });
      }.bind(this));
    }.bind(this))
    .catch(function(err) {
      console.error(err);
      this.setState({ verificandoDescarga: false, compError: 'Error al verificar disponibilidad. Intente nuevamente.' });
    }.bind(this));
  }

  render() {
    let datos = this.props.location.state ? this.props.location.state.datos : null;
    if (!datos) { try { datos = JSON.parse(sessionStorage.getItem('datos')); } catch(e) { datos = null; } }
    if (!datos || !datos[0]) return <Redirect to="/" />;
    if (this.state.volverDashboard) {
      var destino = this.tienePanel() ? '/admin-dashboard' : '/';
      return <Redirect push={false} to={{ pathname: destino, state: { datos: datos } }} />;
    }

    const rol = this.getRol();
    const esOperador = rol === 'OPERADOR';
    const hasData = this.state.boletapdf.length > 0;

    return (
      <div style={{ minHeight: "calc(100vh - 4rem)", background: "#f0f2f5" }}>

        {/* Botón Inicio */}
        <MDBContainer className="pt-4 pb-0">
          {this.tienePanel() && (
            <MDBBtn onClick={() => this.setState({ volverDashboard: true })}
              style={{ borderRadius: '8px', margin: '0 0 12px 0', fontWeight: '500', fontSize: '0.85rem', padding: '8px 20px', background: '#7A1622', border: 'none', color: '#fff' }}>
              <MDBIcon icon="arrow-left" className="mr-2" />Volver al Panel
            </MDBBtn>
          )}
        </MDBContainer>

        {/* Barra de búsqueda DNI */}
        <MDBContainer className="pb-3">
          <MDBCard style={{ borderRadius: '12px', border: 'none', boxShadow: '0 2px 12px rgba(122,22,34,0.12)', overflow: 'hidden' }}>
            <div style={{ background: 'linear-gradient(135deg, #7A1622, #a31d2e)', padding: '14px 24px', display: 'flex', alignItems: 'center', gap: '8px' }}>
              <MDBIcon icon="search-dollar" style={{ color: '#D4A843', fontSize: '1.1rem' }} />
              <span style={{ color: '#fff', fontWeight: '600', fontSize: '0.95rem' }}>Consulta de Boletas de Pago</span>
              {this.state.consultado && (
                <span style={{ color: '#D4A843', fontSize: '0.8rem', marginLeft: 'auto', fontWeight: '500' }}>
                  {esOperador && <span style={{ marginRight: '12px' }}><MDBIcon icon="user-shield" className="mr-1" />OPERADOR</span>}
                  DNI: <strong style={{ letterSpacing: '2px' }}>{this.state.dniConfirmado}</strong>
                </span>
              )}
            </div>
            <MDBCardBody style={{ padding: '20px 24px' }}>
              <form onSubmit={this.handleConsultar}>
                <MDBRow className="align-items-end">
                  <MDBCol md="5" className="mb-2 mb-md-0">
                    {/* 11/08/2026 - un solo campo para las dos cosas: ya no
                        filtra a solo dígitos ni limita a 8 caracteres. */}
                    <label style={{ fontWeight: '600', color: '#555', fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '6px', display: 'block' }}>
                      <MDBIcon icon="id-card" className="mr-1" style={{ color: '#7A1622' }} /> DNI o nombre del trabajador
                    </label>
                    <input type="text" className="form-control" placeholder="22334455  o  DELGADO PACHECO MARIA"
                      value={this.state.dniBusqueda}
                      onChange={(e) => this.alEscribirBusqueda(e.target.value)}
                      maxLength={60} autoFocus
                      style={{ fontWeight: '600', fontSize: '1rem', borderRadius: '8px', border: '2px solid #e0e0e0', padding: '10px 14px' }}
                      onFocus={(e) => { e.target.style.borderColor = '#7A1622'; this.handleDniFocus(); }}
                      onBlur={(e) => e.target.style.borderColor = '#e0e0e0'}
                    />
                  </MDBCol>
                  <MDBCol md="7" className="mb-2 mb-md-0">
                    <div className="d-flex align-items-center" style={{ gap: '10px', paddingBottom: '2px' }}>
                      <MDBBtn type="submit" disabled={this.state.dniBusqueda.trim().length < 3 || this.state.cargando}
                        style={{ borderRadius: '8px', margin: 0, fontWeight: '600', fontSize: '0.85rem', padding: '10px 24px', background: this.state.dniBusqueda.trim().length >= 3 ? 'linear-gradient(135deg, #7A1622, #a31d2e)' : '#ccc', border: 'none', color: '#fff' }}>
                        <MDBIcon icon="search" className="mr-2" />{this.state.cargando ? 'Consultando...' : 'Consultar'}
                      </MDBBtn>
                      {this.state.consultado && (
                        <MDBBtn type="button" outline color="danger" size="sm" style={{ borderRadius: '8px', margin: 0, fontWeight: '500', fontSize: '0.82rem', padding: '9px 18px' }} onClick={this.handleNuevaBusqueda}>
                          <MDBIcon icon="eraser" className="mr-1" /> Nueva consulta
                        </MDBBtn>
                      )}
                    </div>
                  </MDBCol>
                </MDBRow>
              </form>
              {this.state.mensajeError && (
                <div style={{ marginTop: '12px', padding: '10px 16px', backgroundColor: '#fdecea', border: '1px solid #f5c6cb', borderRadius: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <MDBIcon icon="exclamation-triangle" style={{ color: '#c62828', fontSize: '1rem' }} />
                  <span style={{ color: '#c62828', fontWeight: '500', fontSize: '0.88rem' }}>{this.state.mensajeError}</span>
                </div>
              )}
            </MDBCardBody>
          </MDBCard>
        </MDBContainer>

        {/* 11/08/2026 - Antes esta zona era un cartel gris de "Ingrese un DNI".
            Ahora lista trabajadores y se filtra sola mientras se escribe
            arriba, para no tener que saberse el DNI de memoria.

            La columna Vínculo es la que distingue: una misma persona puede
            tener hasta cuatro (CAS, ACO, ADA, DOC), uno por cada contrato. */}
        {!this.state.consultado ? (
          <MDBContainer className="pb-4">
            <MDBCard style={{ borderRadius: '12px', border: 'none', boxShadow: '0 2px 12px rgba(0,0,0,0.07)', overflow: 'hidden' }}>
              <div style={{ background: '#f7f7f9', padding: '12px 20px', borderBottom: '1px solid #e8e8e8', display: 'flex', alignItems: 'center', gap: '10px' }}>
                <MDBIcon icon="users" style={{ color: '#7A1622' }} />
                <span style={{ fontWeight: '600', color: '#444', fontSize: '0.9rem' }}>
                  {this.state.dniBusqueda.trim() ? 'Coincidencias' : 'Trabajadores'}
                </span>
                <span style={{ marginLeft: 'auto', fontSize: '0.82rem', color: '#888' }}>
                  {this.state.buscandoTrabajador
                    ? <span><MDBIcon icon="spinner" spin className="mr-1" />Buscando…</span>
                    : (this.state.resultadosBusqueda.length >= 50
                        ? 'Mostrando los primeros 50 — afine la búsqueda'
                        : this.state.resultadosBusqueda.length + ' resultado(s)')}
                </span>
              </div>

              {this.state.resultadosBusqueda.length === 0 && !this.state.buscandoTrabajador ? (
                <div className="text-center" style={{ padding: '50px 20px' }}>
                  <MDBIcon icon="user-slash" size="2x" style={{ color: '#ccc' }} />
                  <p style={{ color: '#999', marginTop: '14px', marginBottom: 0, fontSize: '0.9rem' }}>
                    No se encontró ningún trabajador con «{this.state.dniBusqueda.trim()}»
                  </p>
                  <p style={{ color: '#bbb', fontSize: '0.82rem' }}>Pruebe con el apellido, o con el DNI completo.</p>
                </div>
              ) : (
                <div style={{ maxHeight: '460px', overflowY: 'auto' }}>
                  <MDBTable hover responsive style={{ marginBottom: 0, fontSize: '0.87rem' }}>
                    <MDBTableHead>
                      <tr style={{ position: 'sticky', top: 0, background: '#fff', zIndex: 1 }}>
                        <th style={{ width: '120px' }}>DNI</th>
                        <th>Apellidos y Nombres</th>
                        <th style={{ width: '180px' }}>Condición</th>
                        <th style={{ width: '110px' }}></th>
                      </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                      {this.state.resultadosBusqueda.map(function(t) {
                        var vinculos = (t.Vinculos || '').split(', ').filter(function(v) { return v; });
                        return (
                          <tr key={t.DNI} style={{ cursor: 'pointer' }}
                              onClick={function() { this.seleccionarTrabajador(t.DNI); }.bind(this)}>
                            <td style={{ fontWeight: '700', letterSpacing: '1px', verticalAlign: 'middle' }}>{t.DNI}</td>
                            <td style={{ verticalAlign: 'middle' }}>{t.NombreCompleto}</td>
                            <td style={{ verticalAlign: 'middle' }}>
                              {vinculos.length === 0 ? (
                                <span style={{ color: '#bbb' }}>—</span>
                              ) : vinculos.map(function(v) {
                                return (
                                  <span key={v} style={{
                                    display: 'inline-block', padding: '2px 8px', marginRight: '4px', marginBottom: '2px',
                                    borderRadius: '10px', fontSize: '0.72rem', fontWeight: '700',
                                    background: '#eceff1', color: '#455A64'
                                  }}>{v}</span>
                                );
                              })}
                            </td>
                            <td style={{ verticalAlign: 'middle', textAlign: 'right' }}>
                              <span style={{ color: '#7A1622', fontWeight: '600', fontSize: '0.82rem' }}>
                                Consultar <MDBIcon icon="arrow-right" className="ml-1" />
                              </span>
                            </td>
                          </tr>
                        );
                      }.bind(this))}
                    </MDBTableBody>
                  </MDBTable>
                </div>
              )}
            </MDBCard>
          </MDBContainer>
        ) : (
          <MDBContainer>

            {/* Datos del trabajador */}
            <MDBCard className="mb-3" style={{ borderTop: '3px solid #2E7D32', borderRadius: '10px' }}>
              <MDBCardBody style={{ padding: '20px 24px' }}>
                <h6 style={{ color: '#2E7D32', fontWeight: '600', marginBottom: '14px' }}>
                  <MDBIcon icon="user-tie" className="mr-2" />Datos del Trabajador
                </h6>
                <MDBRow>
                  {(() => {
                    const dp = this.state.datosPersonales;
                    const get = (desc) => { const f = dp.find(d => d.descripcion === desc); return f ? f.nombre : ''; };
                    const nombres = get('Nombres');
                    const apPaterno = get('Ap. Paterno');
                    const apMaterno = get('Ap. Materno');
                    const dni = get('Dni');
                    const trabajador = get('Trabajador');
                    return (
                      <>
                        <MDBCol md="8" className="mb-2">
                          <small style={{ color: '#888', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Apellidos y Nombres</small>
                          <div style={{ fontWeight: '800', fontSize: '1.35rem', color: '#222', letterSpacing: '0.3px' }}>
                            {apPaterno} {apMaterno} {nombres}
                          </div>
                        </MDBCol>
                        <MDBCol md="2" className="mb-2">
                          <small style={{ color: '#888', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>DNI</small>
                          <div style={{ fontWeight: '700', fontSize: '1.15rem', color: '#333', letterSpacing: '2px' }}>{dni}</div>
                        </MDBCol>
                        <MDBCol md="2" className="mb-2">
                          <small style={{ color: '#888', fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Código</small>
                          <div style={{ fontWeight: '700', fontSize: '1.15rem', color: '#333' }}>{trabajador}</div>
                        </MDBCol>
                      </>
                    );
                  })()}
                </MDBRow>
              </MDBCardBody>
            </MDBCard>

            {/* Panel de Comprobante - Solo OPERADOR */}
            {esOperador && (
              <MDBCard className="mb-3" style={{ borderTop: '3px solid #F57C00', borderRadius: '10px' }}>
                <MDBCardBody style={{ padding: '16px 20px' }}>
                  <h6 style={{ color: '#F57C00', fontWeight: '600', marginBottom: '12px' }}>
                    <MDBIcon icon="receipt" className="mr-2" />
                    {this.state.compTipo === 'EXPEDIENTE' ? 'Expediente' : 'Comprobante de Pago'}
                  </h6>
                  {this.state.compRegistrado ? (
                    this.esExpediente() ? (
                      /* 11/08/2026 - Resumen de un expediente: no lleva monto ni
                         tope, solo cuántas boletas se han entregado por él. */
                      <div style={{ background: '#e0f7fa', borderRadius: '8px', padding: '12px 16px', border: '1px solid #80deea' }}>
                        <MDBRow>
                          <MDBCol md="5">
                            <small style={{ color: '#888', fontSize: '0.72rem', textTransform: 'uppercase' }}>Expediente</small>
                            <div style={{ fontWeight: '700', color: '#00838F' }}>{this.state.compExpediente}</div>
                          </MDBCol>
                          <MDBCol md="3">
                            <small style={{ color: '#888', fontSize: '0.72rem', textTransform: 'uppercase' }}>Entregadas</small>
                            <div style={{ fontWeight: '700', color: '#00838F', fontSize: '1.1rem' }}>{this.state.compDescargasRealizadas}</div>
                          </MDBCol>
                          {/* 13/08/2026 - Una solicitud puede cubrir a varios
                              trabajadores; se muestra cuántos van para que
                              quien atiende confirme que es la correcta. */}
                          <MDBCol md="2">
                            <small style={{ color: '#888', fontSize: '0.72rem', textTransform: 'uppercase' }}>Trabajadores</small>
                            <div style={{ fontWeight: '700', color: '#00838F', fontSize: '1.1rem' }}>
                              {this.state.compTrabajadoresExpediente || 1}
                            </div>
                          </MDBCol>
                          <MDBCol md="2">
                            <small style={{ color: '#888', fontSize: '0.72rem', textTransform: 'uppercase' }}>Tope</small>
                            <div style={{ fontWeight: '700', color: '#00838F', fontSize: '1.1rem' }}>Sin límite</div>
                          </MDBCol>
                        </MDBRow>
                        {this.state.compMensaje && <div style={{ marginTop: '8px', color: '#00838F', fontSize: '0.85rem', fontWeight: '500' }}><MDBIcon icon="check-circle" className="mr-1" />{this.state.compMensaje}</div>}
                      </div>
                    ) : (
                    <div style={{ background: '#e8f5e9', borderRadius: '8px', padding: '12px 16px', border: '1px solid #a5d6a7' }}>
                      <MDBRow>
                        <MDBCol md="4">
                          <small style={{ color: '#888', fontSize: '0.72rem', textTransform: 'uppercase' }}>Comprobante</small>
                          <div style={{ fontWeight: '700', color: '#2E7D32' }}>{this.state.compSerie}-{this.state.compNumero}</div>
                        </MDBCol>
                        <MDBCol md="3">
                          <small style={{ color: '#888', fontSize: '0.72rem', textTransform: 'uppercase' }}>Monto</small>
                          <div style={{ fontWeight: '700', color: '#2E7D32' }}>S/ {this.state.compMonto}</div>
                        </MDBCol>
                        <MDBCol md="2">
                          <small style={{ color: '#888', fontSize: '0.72rem', textTransform: 'uppercase' }}>Permitidas</small>
                          <div style={{ fontWeight: '700', color: '#1565C0', fontSize: '1.1rem' }}>{this.state.compDescargasPermitidas}</div>
                        </MDBCol>
                        <MDBCol md="3">
                          <small style={{ color: '#888', fontSize: '0.72rem', textTransform: 'uppercase' }}>Restantes</small>
                          <div style={{ fontWeight: '700', color: this.state.compDescargasPermitidas - this.state.compDescargasRealizadas > 0 ? '#2E7D32' : '#C62828', fontSize: '1.1rem' }}>
                            {this.state.compDescargasPermitidas - this.state.compDescargasRealizadas}
                          </div>
                        </MDBCol>
                      </MDBRow>
                      {this.state.compMensaje && <div style={{ marginTop: '8px', color: '#2E7D32', fontSize: '0.85rem', fontWeight: '500' }}><MDBIcon icon="check-circle" className="mr-1" />{this.state.compMensaje}</div>}
                    </div>
                    )
                  ) : (
                    <div>
                      {/* 11/08/2026 - Selector de procedencia. El trabajador puede
                          llegar con un pago o con un expediente; el expediente no
                          lleva ni número de comprobante ni monto. */}
                      <div style={{ display: 'flex', gap: '8px', marginBottom: '14px', flexWrap: 'wrap' }}>
                        {[
                          { valor: 'COMPROBANTE', icono: 'receipt', texto: 'Comprobante de pago', color: '#F57C00' },
                          { valor: 'EXPEDIENTE', icono: 'folder-open', texto: 'Expediente', color: '#00838F' }
                        ].map(function(opcion) {
                          var activo = this.state.compTipo === opcion.valor;
                          return (
                            <button
                              key={opcion.valor}
                              type="button"
                              onClick={function() {
                                this.setState({ compTipo: opcion.valor, compError: '' });
                              }.bind(this)}
                              style={{
                                flex: '1 1 200px', padding: '10px 16px', borderRadius: '8px', cursor: 'pointer',
                                fontWeight: '600', fontSize: '0.88rem', textAlign: 'left',
                                border: activo ? ('2px solid ' + opcion.color) : '2px solid #e0e0e0',
                                background: activo ? (opcion.color + '14') : '#fff',
                                color: activo ? opcion.color : '#777'
                              }}>
                              <MDBIcon icon={activo ? 'dot-circle' : 'circle'} far={!activo} className="mr-2" />
                              <MDBIcon icon={opcion.icono} className="mr-2" />
                              {opcion.texto}
                            </button>
                          );
                        }.bind(this))}
                      </div>

                      {this.state.compTipo === 'EXPEDIENTE' ? (
                        <MDBRow>
                          <MDBCol md="8" className="mb-2">
                            <label style={{ fontWeight: '500', fontSize: '0.85rem', color: '#555' }}>N° de expediente</label>
                            <input type="text" className="form-control" placeholder="Ej: EXP-26069846"
                              value={this.state.compExpediente}
                              onChange={(e) => this.setState({ compExpediente: e.target.value, compError: '' })}
                              onKeyDown={(e) => { if (e.key === 'Enter') this.handleRegistrarComprobante(); }} />
                            <small style={{ color: '#888', fontSize: '0.78rem' }}>
                              No lleva monto. Las descargas quedan registradas para el control, sin tope.
                              {' '}Si la solicitud cubre a varios trabajadores, use el <strong>mismo número</strong> con cada uno.
                            </small>
                          </MDBCol>
                          <MDBCol md="4" className="mb-2 d-flex align-items-start" style={{ paddingTop: '22px' }}>
                            <MDBBtn onClick={this.handleRegistrarComprobante} style={{ borderRadius: '8px', margin: 0, fontWeight: '600', fontSize: '0.82rem', padding: '10px 16px', background: '#00838F', border: 'none', color: '#fff', width: '100%' }}>
                              <MDBIcon icon="check" className="mr-1" />Registrar expediente
                            </MDBBtn>
                          </MDBCol>
                        </MDBRow>
                      ) : (
                      <>
                      <MDBRow>
                        <MDBCol md="3" className="mb-2">
                          <label style={{ fontWeight: '500', fontSize: '0.85rem', color: '#555' }}>Serie</label>
                          <input type="text" className="form-control" placeholder="Ej: E001" value={this.state.compSerie} onChange={(e) => this.setState({ compSerie: e.target.value, compError: '' })} />
                        </MDBCol>
                        <MDBCol md="4" className="mb-2">
                          <label style={{ fontWeight: '500', fontSize: '0.85rem', color: '#555' }}>Número</label>
                          <input type="text" className="form-control" placeholder="Ej: 00001234" value={this.state.compNumero} onChange={(e) => this.setState({ compNumero: e.target.value, compError: '' })} />
                        </MDBCol>
                        <MDBCol md="2" className="mb-2">
                          <label style={{ fontWeight: '500', fontSize: '0.85rem', color: '#555' }}>Monto (S/)</label>
                          <input type="number" step="0.01" className="form-control" placeholder="Ej: 30.00" value={this.state.compMonto} onChange={(e) => this.setState({ compMonto: e.target.value, compError: '' })} />
                        </MDBCol>
                        <MDBCol md="2" className="mb-2 d-flex align-items-end">
                          <MDBBtn onClick={this.handleRegistrarComprobante} style={{ borderRadius: '8px', margin: 0, fontWeight: '600', fontSize: '0.82rem', padding: '10px 16px', background: '#F57C00', border: 'none', color: '#fff', width: '100%' }}>
                            <MDBIcon icon="check" className="mr-1" />Registrar
                          </MDBBtn>
                        </MDBCol>
                      </MDBRow>
                      {this.state.compMonto && parseFloat(this.state.compMonto) >= 3 && (() => {
                        var montoNum = parseFloat(this.state.compMonto);
                        var cantBoletas = Math.floor(montoNum / 3);
                        var residuo = Math.round((montoNum - cantBoletas * 3) * 100) / 100;
                        return (
                          <div style={{ marginTop: '12px', background: '#e3f2fd', borderRadius: '8px', padding: '12px 20px', border: '1px solid #bbdefb' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                              <MDBIcon icon="file-invoice-dollar" style={{ color: '#1565C0', fontSize: '1.4rem' }} />
                              <span style={{ fontSize: '1.1rem', color: '#1565C0', fontWeight: '700' }}>
                                Boletas a descargar: <span style={{ fontSize: '1.4rem' }}>{cantBoletas}</span>
                              </span>
                              <span style={{ fontSize: '0.85rem', color: '#666', marginLeft: '8px' }}>
                                (S/ {this.state.compMonto} ÷ S/ 3.00)
                              </span>
                            </div>
                            {residuo > 0 && (
                              <div style={{ marginTop: '8px', background: '#fff8e1', borderRadius: '6px', padding: '6px 12px', display: 'flex', alignItems: 'center', gap: '8px', border: '1px solid #ffe082' }}>
                                <MDBIcon icon="info-circle" style={{ color: '#F57C00', fontSize: '1rem' }} />
                                <span style={{ fontSize: '0.9rem', color: '#E65100', fontWeight: '600' }}>
                                  Diferencia: S/ {residuo.toFixed(2)}
                                </span>
                              </div>
                            )}
                          </div>
                        );
                      })()}
                      </>
                      )}
                    </div>
                  )}
                  {this.state.compError && (
                    <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <div style={{ background: '#fff', borderRadius: '12px', padding: '30px 40px', maxWidth: '500px', width: '90%', textAlign: 'center', boxShadow: '0 10px 40px rgba(0,0,0,0.3)' }}>
                        <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: '#fdecea', margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <MDBIcon icon="exclamation-triangle" style={{ color: '#c62828', fontSize: '1.8rem' }} />
                        </div>
                        <p style={{ fontSize: '1.2rem', fontWeight: '700', color: '#c62828', marginBottom: '20px' }}>{this.state.compError}</p>
                        <MDBBtn onClick={() => this.setState({ compError: '' })} style={{ borderRadius: '8px', fontWeight: '600', fontSize: '0.9rem', padding: '10px 40px', background: '#7A1622', border: 'none', color: '#fff' }}>
                          <MDBIcon icon="times" className="mr-2" />Cerrar
                        </MDBBtn>
                      </div>
                    </div>
                  )}
                </MDBCardBody>
              </MDBCard>
            )}

            {/* Filtros: Condición → Periodo → Planilla */}
            {esOperador && !this.state.compRegistrado && (
              <div style={{ marginBottom: '12px', padding: '10px 16px', backgroundColor: '#fff3e0', border: '1px solid #ffe0b2', borderRadius: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <MDBIcon icon="lock" style={{ color: '#F57C00', fontSize: '1rem' }} />
                <span style={{ color: '#E65100', fontWeight: '500', fontSize: '0.88rem' }}>Registre el comprobante de pago o el expediente para habilitar la consulta y descarga de boletas</span>
              </div>
            )}
            <MDBCard className="mb-3" style={{ borderTop: '3px solid #7A1622', borderRadius: '10px', opacity: esOperador && !this.state.compRegistrado ? 0.5 : 1, pointerEvents: esOperador && !this.state.compRegistrado ? 'none' : 'auto' }}>
              <MDBCardBody style={{ padding: '16px 20px' }}>
                <h6 style={{ color: '#7A1622', fontWeight: '600', marginBottom: '12px' }}>
                  <MDBIcon icon="filter" className="mr-2" />Planillas Remunerativas
                </h6>
                <MDBRow>
                  {/* Condición Laboral */}
                  <MDBCol md="12" className="mb-3">
                    <label style={{ fontWeight: '500', fontSize: '0.85rem', color: '#555' }}>Condición Laboral</label>
                    <select className="browser-default custom-select" onChange={this.handleCondicionChange} value={this.state.usuario || ""}>
                      <option value="" hidden>-- Seleccione condición --</option>
                      {this.state.condicionesLaborales.filter(s => s.trabajador != null && String(s.trabajador).trim() !== '').map(s => (
                        <option key={s.trabajador} value={String(s.trabajador).trim()}>{s.nombre}</option>
                      ))}
                    </select>
                  </MDBCol>

                  {/* Periodo */}
                  <MDBCol md="3" className="mb-3">
                    <label style={{ fontWeight: '500', fontSize: '0.85rem', color: '#555' }}>Periodo</label>
                    <Select
                      ref={this.refPeriodoRem}
                      options={this.state.periodos.map(s => ({ value: s.periodo, label: s.detalle }))}
                      onChange={(opt) => this.handlePeriodoChange({ target: { value: opt ? opt.value : '' } })}
                      value={this.state.periodoSeleccionado ? this.state.periodos.filter(s => s.periodo === this.state.periodoSeleccionado).map(s => ({ value: s.periodo, label: s.detalle }))[0] : null}
                      placeholder="Buscar periodo..."
                      isClearable
                      isSearchable
                      isDisabled={this.state.periodos.length === 0}
                      menuPlacement="auto"
                      menuPortalTarget={document.body}
                      onMenuOpen={() => {
                        var sel = this.state.periodos.find(s => s.periodo === this.state.periodoSeleccionado);
                        this.scrollToSelected(sel ? sel.detalle : '');
                      }}
                      filterOption={(option, input) => !input || option.label.toLowerCase().includes(input.toLowerCase())}
                      noOptionsMessage={() => 'No se encontraron periodos'}
                      styles={{
                        control: (base, state) => ({ ...base, borderColor: state.isFocused ? '#7A1622' : '#ced4da', boxShadow: state.isFocused ? '0 0 0 1px #7A1622' : 'none', fontSize: '0.92rem' }),
                        option: (base, state) => ({ ...base, fontSize: '0.92rem', padding: '10px 12px', backgroundColor: state.isSelected ? '#7A1622' : state.isFocused ? '#fdecea' : '#fff', color: state.isSelected ? '#fff' : '#222', fontWeight: state.isSelected ? '600' : '400' }),
                        placeholder: (base) => ({ ...base, color: '#999', fontSize: '0.92rem' }),
                        singleValue: (base) => ({ ...base, color: '#222', fontSize: '0.92rem', fontWeight: '500' }),
                        menuPortal: (base) => ({ ...base, zIndex: 9999 })
                      }}
                    />
                  </MDBCol>

                  {/* Planilla Remunerativa */}
                  <MDBCol md="9" className="mb-3">
                    <label style={{ fontWeight: '500', fontSize: '0.85rem', color: '#555' }}>Planilla</label>
                    <Select
                      options={this.state.planillas.map(s => ({ value: s.value, label: s.text || "" }))}
                      onChange={this.handlePlanillaChange}
                      value={this.state.planillaSeleccionada ? this.state.planillas.filter(s => s.value === this.state.planillaSeleccionada).map(s => ({ value: s.value, label: s.text || "" }))[0] : null}
                      placeholder={this.state.periodoSeleccionado ? "Seleccione planilla..." : "Primero seleccione un periodo"}
                      isClearable
                      isSearchable
                      isDisabled={!this.state.periodoSeleccionado}
                      filterOption={(option, input) => !input || option.label.toLowerCase().includes(input.toLowerCase())}
                      noOptionsMessage={() => 'No se encontraron planillas remunerativas en este periodo'}
                      styles={{
                        control: (base, state) => ({ ...base, borderColor: state.isFocused ? '#7A1622' : '#ced4da', boxShadow: state.isFocused ? '0 0 0 1px #7A1622' : 'none', fontSize: '0.92rem' }),
                        option: (base, state) => ({ ...base, fontSize: '0.92rem', padding: '10px 12px', backgroundColor: state.isSelected ? '#7A1622' : state.isFocused ? '#fdecea' : '#fff', color: state.isSelected ? '#fff' : '#222', fontWeight: state.isSelected ? '600' : '400' }),
                        placeholder: (base) => ({ ...base, color: '#999', fontSize: '0.92rem' })
                      }}
                    />
                  </MDBCol>
                </MDBRow>
                {hasData && (
                  <div style={{ marginTop: '8px', display: 'flex', gap: '10px' }}>
                    <MDBBtn
                      onClick={this.descargarPDF}
                      disabled={(esOperador && !this.state.compRegistrado) || this.state.verificandoDescarga}
                      style={{
                        borderRadius: '10px', margin: 0, fontSize: '0.9rem', padding: '11px 24px', fontWeight: '600',
                        backgroundColor: '#7A1622', color: '#fff', border: 'none', flex: 1,
                        boxShadow: '0 3px 10px rgba(122,22,34,0.2)'
                      }}
                    >
                      <MDBIcon icon={this.state.verificandoDescarga ? 'spinner' : 'file-pdf'} spin={this.state.verificandoDescarga} className="mr-2" />
                      {this.state.verificandoDescarga ? 'Procesando...' : 'Descargar Boleta'}
                    </MDBBtn>
                    <MDBBtn
                      onClick={() => this.setState({ mostrarDetalle: !this.state.mostrarDetalle })}
                      style={{
                        borderRadius: '10px', margin: 0, fontSize: '0.9rem', padding: '11px 24px', fontWeight: '600',
                        backgroundColor: '#E65100', color: '#fff', border: 'none',
                        boxShadow: '0 3px 10px rgba(230,81,0,0.2)'
                      }}
                    >
                      <MDBIcon icon={this.state.mostrarDetalle ? 'eye-slash' : 'eye'} className="mr-2" />
                      {this.state.mostrarDetalle ? 'Ocultar Detalle' : 'Ver Detalle'}
                    </MDBBtn>
                  </div>
                )}
              </MDBCardBody>
            </MDBCard>

            {/* Detalle de la boleta */}
            {hasData && this.state.mostrarDetalle && (
              <MDBCard className="mb-4" style={{ borderTop: '3px solid #E65100', borderRadius: '10px' }}>
                <MDBCardBody>
                  <h6 style={{ color: '#E65100', fontWeight: '600', marginBottom: '12px' }}>
                    <MDBIcon icon="list-alt" className="mr-2" />Detalle de la Boleta
                  </h6>
                  <MDBTable striped small style={{ fontSize: '0.8rem' }}>
                    <MDBTableHead>
                      <tr>
                        <th colSpan={2} style={{ textAlign: 'left', fontWeight: 'bold', color: '#2E7D32' }}>Remuneración</th>
                        <th colSpan={2} style={{ textAlign: 'left', fontWeight: 'bold', color: '#C62828' }}>Descuento</th>
                      </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                      {this.state.boletapdf.map(fila => (
                        ((fila.nomrem !== "" && fila.monrem !== "") &&
                        <tr key={fila.nomrem}>
                          <td>{fila.nomrem}</td>
                          <td style={{ color: '#2E7D32', fontWeight: '600' }}>{fila.monrem}</td>
                          <td>{fila.nomdes}</td>
                          <td style={{ color: '#C62828', fontWeight: '600' }}>{fila.mondes}</td>
                        </tr>
                        )
                      ))}
                    </MDBTableBody>
                  </MDBTable>
                </MDBCardBody>
              </MDBCard>
            )}


            {/* ============ OTRAS PLANILLAS ============ */}
            <MDBCard className="mb-3" ref={this.refOtrasCard} style={{ borderTop: '3px solid #1565C0', borderRadius: '10px', opacity: esOperador && !this.state.compRegistrado ? 0.5 : 1, pointerEvents: esOperador && !this.state.compRegistrado ? 'none' : 'auto' }}>
              <MDBCardBody style={{ padding: '16px 20px' }}>
                <h6 style={{ color: '#1565C0', fontWeight: '600', marginBottom: '12px' }}>
                  <MDBIcon icon="folder-open" className="mr-2" />Otras Planillas
                </h6>
                <MDBRow>
                  <MDBCol md="3" className="mb-3">
                    <label style={{ fontWeight: '500', fontSize: '0.85rem', color: '#555' }}>Periodo</label>
                    <Select
                      ref={this.refPeriodoOtras}
                      options={this.state.otrasPeriodos.map(s => ({ value: s.periodo, label: s.detalle }))}
                      onChange={(opt) => this.handleOtrasPeriodoChange({ target: { value: opt ? opt.value : '' } })}
                      value={this.state.otrasPeriodoSel ? this.state.otrasPeriodos.filter(s => s.periodo === this.state.otrasPeriodoSel).map(s => ({ value: s.periodo, label: s.detalle }))[0] : null}
                      placeholder="Buscar periodo..."
                      isClearable
                      isSearchable
                      isDisabled={!this.state.usuario || this.state.otrasPeriodos.length === 0}
                      menuPlacement="auto"
                      menuPortalTarget={document.body}
                      onMenuOpen={() => {
                        var sel = this.state.otrasPeriodos.find(s => s.periodo === this.state.otrasPeriodoSel);
                        this.scrollToSelected(sel ? sel.detalle : '');
                      }}
                      filterOption={(option, input) => !input || option.label.toLowerCase().includes(input.toLowerCase())}
                      noOptionsMessage={() => 'No se encontraron periodos'}
                      styles={{
                        control: (base, state) => ({ ...base, borderColor: state.isFocused ? '#1565C0' : '#ced4da', boxShadow: state.isFocused ? '0 0 0 1px #1565C0' : 'none', fontSize: '0.92rem' }),
                        option: (base, state) => ({ ...base, fontSize: '0.92rem', padding: '10px 12px', backgroundColor: state.isSelected ? '#1565C0' : state.isFocused ? '#e3f2fd' : '#fff', color: state.isSelected ? '#fff' : '#222', fontWeight: state.isSelected ? '600' : '400' }),
                        placeholder: (base) => ({ ...base, color: '#999', fontSize: '0.92rem' }),
                        singleValue: (base) => ({ ...base, color: '#222', fontSize: '0.92rem', fontWeight: '500' }),
                        menuPortal: (base) => ({ ...base, zIndex: 9999 })
                      }}
                    />
                  </MDBCol>
                  <MDBCol md="9" className="mb-3">
                    <label style={{ fontWeight: '500', fontSize: '0.85rem', color: '#555' }}>Planilla</label>
                    <Select
                      options={this.state.otrasPlanillasDisp.map(s => ({ value: s.value, label: s.text || "" }))}
                      onChange={this.handleOtrasPlanillaChange}
                      value={this.state.otrasPlanillaSel ? this.state.otrasPlanillasDisp.filter(s => s.value === this.state.otrasPlanillaSel).map(s => ({ value: s.value, label: s.text || "" }))[0] : null}
                      placeholder={this.state.otrasPeriodoSel ? "Seleccione planilla..." : "Primero seleccione un periodo"}
                      isClearable
                      isSearchable
                      isDisabled={!this.state.otrasPeriodoSel}
                      menuPlacement="auto"
                      menuPortalTarget={document.body}
                      filterOption={(option, input) => !input || option.label.toLowerCase().includes(input.toLowerCase())}
                      noOptionsMessage={() => 'No se encontraron planillas en este periodo'}
                      styles={{
                        control: (base, state) => ({ ...base, borderColor: state.isFocused ? '#1565C0' : '#ced4da', boxShadow: state.isFocused ? '0 0 0 1px #1565C0' : 'none', fontSize: '0.92rem' }),
                        option: (base, state) => ({ ...base, fontSize: '0.92rem', padding: '10px 12px', backgroundColor: state.isSelected ? '#1565C0' : state.isFocused ? '#e3f2fd' : '#fff', color: state.isSelected ? '#fff' : '#222', fontWeight: state.isSelected ? '600' : '400' }),
                        placeholder: (base) => ({ ...base, color: '#999', fontSize: '0.92rem' }),
                        menuPortal: (base) => ({ ...base, zIndex: 9999 })
                      }}
                    />
                  </MDBCol>
                </MDBRow>
                {this.state.otrasBoletapdf.length > 0 && (
                  <div style={{ marginTop: '8px', display: 'flex', gap: '10px' }}>
                    <MDBBtn
                      onClick={this.descargarOtrasPDFConControl}
                      disabled={(esOperador && !this.state.compRegistrado) || this.state.verificandoDescarga}
                      style={{
                        borderRadius: '10px', margin: 0, fontSize: '0.9rem', padding: '11px 24px', fontWeight: '600',
                        backgroundColor: '#1565C0', color: '#fff', border: 'none', flex: 1,
                        boxShadow: '0 3px 10px rgba(21,101,192,0.2)'
                      }}
                    >
                      <MDBIcon icon={this.state.verificandoDescarga ? 'spinner' : 'file-pdf'} spin={this.state.verificandoDescarga} className="mr-2" />
                      {this.state.verificandoDescarga ? 'Procesando...' : 'Descargar Boleta'}
                    </MDBBtn>
                    <MDBBtn
                      onClick={() => this.setState({ mostrarDetalleOtras: !this.state.mostrarDetalleOtras })}
                      style={{
                        borderRadius: '10px', margin: 0, fontSize: '0.9rem', padding: '11px 24px', fontWeight: '600',
                        backgroundColor: '#E65100', color: '#fff', border: 'none',
                        boxShadow: '0 3px 10px rgba(230,81,0,0.2)'
                      }}
                    >
                      <MDBIcon icon={this.state.mostrarDetalleOtras ? 'eye-slash' : 'eye'} className="mr-2" />
                      {this.state.mostrarDetalleOtras ? 'Ocultar Detalle' : 'Ver Detalle'}
                    </MDBBtn>
                  </div>
                )}
              </MDBCardBody>
            </MDBCard>

            {/* Detalle Otras Planillas */}
            {this.state.otrasBoletapdf.length > 0 && this.state.mostrarDetalleOtras && (
              <MDBCard className="mb-4" style={{ borderTop: '3px solid #1565C0', borderRadius: '10px' }}>
                <MDBCardBody>
                  <h6 style={{ color: '#1565C0', fontWeight: '600', marginBottom: '12px' }}>
                    <MDBIcon icon="list-alt" className="mr-2" />Detalle - Otras Planillas
                  </h6>
                  <MDBTable striped small style={{ fontSize: '0.8rem' }}>
                    <MDBTableHead>
                      <tr>
                        <th colSpan={2} style={{ textAlign: 'left', fontWeight: 'bold', color: '#2E7D32' }}>Remuneración</th>
                        <th colSpan={2} style={{ textAlign: 'left', fontWeight: 'bold', color: '#C62828' }}>Descuento</th>
                      </tr>
                    </MDBTableHead>
                    <MDBTableBody>
                      {this.state.otrasBoletapdf.map(fila => (
                        ((fila.nomrem !== "" && fila.monrem !== "") &&
                        <tr key={fila.nomrem}>
                          <td>{fila.nomrem}</td>
                          <td style={{ color: '#2E7D32', fontWeight: '600' }}>{fila.monrem}</td>
                          <td>{fila.nomdes}</td>
                          <td style={{ color: '#C62828', fontWeight: '600' }}>{fila.mondes}</td>
                        </tr>
                        )
                      ))}
                    </MDBTableBody>
                  </MDBTable>
                </MDBCardBody>
              </MDBCard>
            )}

          </MDBContainer>
        )}

        {/* Modal comprobante pendiente al re-consultar DNI */}
        {this.state.modalCompPendiente && this.state.compPendienteData && (
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.55)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ background: '#fff', borderRadius: '14px', padding: '32px 36px', maxWidth: '520px', width: '92%', textAlign: 'center', boxShadow: '0 10px 40px rgba(0,0,0,0.3)' }}>
              <div style={{ width: '64px', height: '64px', borderRadius: '50%', background: '#e3f2fd', margin: '0 auto 18px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <MDBIcon icon="file-invoice-dollar" style={{ color: '#1565C0', fontSize: '2rem' }} />
              </div>
              {/* 11/08/2026 - el pendiente puede ser un comprobante (con saldo)
                  o un expediente (sin tope), y se describen distinto. */}
              {this.state.compPendienteData.TipoDocumento === 'EXPEDIENTE' ? (
                <>
                  <p style={{ fontSize: '1.15rem', fontWeight: '700', color: '#00838F', marginBottom: '10px' }}>Expediente abierto</p>
                  <p style={{ fontSize: '0.95rem', color: '#444', marginBottom: '6px' }}>
                    Este trabajador tiene un expediente activo, sin tope de descargas.
                  </p>
                  <div style={{ background: '#f5f5f5', borderRadius: '8px', padding: '10px 16px', margin: '12px 0 20px', display: 'inline-block', textAlign: 'left' }}>
                    <div style={{ fontSize: '0.88rem', color: '#555' }}>
                      Expediente: <strong style={{ color: '#00838F' }}>{this.state.compPendienteData.SerieNumero}</strong>
                    </div>
                    <div style={{ fontSize: '0.88rem', color: '#555', marginTop: '4px' }}>
                      Boletas entregadas: <strong>{this.state.compPendienteData.DescargasRealizadas}</strong>
                    </div>
                  </div>
                  <p style={{ fontSize: '0.88rem', color: '#666', marginBottom: '22px' }}>¿Desea continuar con este expediente o registrar otro documento?</p>
                </>
              ) : (
                <>
                  <p style={{ fontSize: '1.15rem', fontWeight: '700', color: '#1565C0', marginBottom: '10px' }}>Descarga(s) pendiente(s)</p>
                  <p style={{ fontSize: '0.95rem', color: '#444', marginBottom: '6px' }}>
                    Este trabajador tiene un comprobante activo con{' '}
                    <span style={{ fontWeight: '800', color: '#C62828', fontSize: '1.2rem' }}>
                      {this.state.compPendienteData.CantidadBoletas - this.state.compPendienteData.DescargasRealizadas}
                    </span>{' '}
                    descarga(s) restante(s).
                  </p>
                  <div style={{ background: '#f5f5f5', borderRadius: '8px', padding: '10px 16px', margin: '12px 0 20px', display: 'inline-block', textAlign: 'left' }}>
                    <div style={{ fontSize: '0.88rem', color: '#555' }}>
                      Comprobante: <strong style={{ color: '#E65100' }}>{this.state.compPendienteData.SerieNumero}</strong>
                    </div>
                    <div style={{ fontSize: '0.88rem', color: '#555', marginTop: '4px' }}>
                      Monto: <strong>S/ {this.state.compPendienteData.MontoPagado}</strong>
                      <span style={{ marginLeft: '16px' }}>Descargadas: <strong>{this.state.compPendienteData.DescargasRealizadas}</strong> / {this.state.compPendienteData.CantidadBoletas}</span>
                    </div>
                  </div>
                  <p style={{ fontSize: '0.88rem', color: '#666', marginBottom: '22px' }}>¿Desea continuar con este comprobante o registrar uno nuevo?</p>
                </>
              )}
              <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                <MDBBtn onClick={this.continuarConComprobanteExistente}
                  style={{ borderRadius: '8px', fontWeight: '600', fontSize: '0.9rem', padding: '10px 28px', background: '#1565C0', border: 'none', color: '#fff' }}>
                  <MDBIcon icon="redo" className="mr-2" />Continuar
                </MDBBtn>
                <MDBBtn onClick={this.continuarSinComprobanteExistente}
                  style={{ borderRadius: '8px', fontWeight: '600', fontSize: '0.9rem', padding: '10px 28px', background: '#7A1622', border: 'none', color: '#fff' }}>
                  <MDBIcon icon="plus" className="mr-2" />Registrar nuevo
                </MDBBtn>
              </div>
            </div>
          </div>
        )}

        {/* Modal de confirmación - Nueva consulta */}
        {this.state.mostrarConfirmacion && (
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ background: '#fff', borderRadius: '12px', padding: '30px 40px', maxWidth: '500px', width: '90%', textAlign: 'center', boxShadow: '0 10px 40px rgba(0,0,0,0.3)' }}>
              <div style={{ width: '60px', height: '60px', borderRadius: '50%', background: '#fff3e0', margin: '0 auto 16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <MDBIcon icon="question-circle" style={{ color: '#F57C00', fontSize: '1.8rem' }} />
              </div>
              <p style={{ fontSize: '1.15rem', fontWeight: '700', color: '#333', marginBottom: '8px' }}>¿Está seguro que desea terminar el proceso?</p>
              <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: '24px' }}>Se perderán los datos del comprobante actual y podrá consultar otro DNI.</p>
              <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                <MDBBtn onClick={this.ejecutarNuevaBusqueda} style={{ borderRadius: '8px', fontWeight: '600', fontSize: '0.9rem', padding: '10px 36px', background: '#7A1622', border: 'none', color: '#fff' }}>
                  <MDBIcon icon="check" className="mr-2" />Sí
                </MDBBtn>
                <MDBBtn onClick={() => this.setState({ mostrarConfirmacion: false })} style={{ borderRadius: '8px', fontWeight: '600', fontSize: '0.9rem', padding: '10px 36px', background: '#666', border: 'none', color: '#fff' }}>
                  <MDBIcon icon="times" className="mr-2" />No
                </MDBBtn>
              </div>
            </div>
          </div>
        )}

        {/* Notificaciones de extras - esquina superior derecha */}
        {this.state.notificaciones.length > 0 && (
          <div style={{ position: 'fixed', top: '5rem', right: '20px', zIndex: 9998, display: 'flex', flexDirection: 'column', gap: '10px', maxWidth: '420px' }}>
            {this.state.notificaciones.map(function(n) {
              return (
                <div key={n.id_notificacion} style={{
                  background: '#fff', borderRadius: '12px', boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                  borderLeft: '5px solid #2E7D32', padding: '20px 22px', animation: 'slideIn 0.3s ease'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '12px' }}>
                    <div style={{ width: '38px', height: '38px', borderRadius: '50%', background: '#e8f5e9', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      <MDBIcon icon="bell" style={{ color: '#2E7D32', fontSize: '1.1rem' }} />
                    </div>
                    <span style={{ fontWeight: '700', color: '#2E7D32', fontSize: '1rem' }}>Descargas extras habilitadas</span>
                  </div>
                  <p style={{ margin: '0 0 8px 0', fontSize: '1.05rem', color: '#333', lineHeight: '1.5' }}>
                    Se habilitaron <span style={{ fontWeight: '800', color: '#1565C0', fontSize: '1.3rem' }}>{n.extras_agregados}</span> descargas extras
                  </p>
                  <p style={{ margin: '0 0 4px 0', fontSize: '0.95rem', color: '#555' }}>
                    Comprobante: <span style={{ fontWeight: '700', color: '#E65100', fontSize: '1.05rem' }}>{n.SerieNumero}</span>
                  </p>
                  <p style={{ margin: '0 0 14px 0', fontSize: '0.95rem', color: '#555' }}>
                    DNI: <span style={{ fontWeight: '800', letterSpacing: '2px', fontSize: '1.1rem', color: '#222' }}>{n.dni_trabajador}</span>
                  </p>
                  <button type="button" onClick={function() { this.procederConNotificacion(n); }.bind(this)}
                    style={{ borderRadius: '8px', padding: '10px 20px', backgroundColor: '#2E7D32', border: 'none', color: '#fff', fontSize: '0.95rem', fontWeight: '700', cursor: 'pointer', width: '100%' }}>
                    <MDBIcon icon="check" className="mr-2" />Entendido, proceder
                  </button>
                </div>
              );
            }.bind(this))}
          </div>
        )}
      </div>
    );
  }
}

export default AdminBoletas;
